import { useEffect, useRef } from 'react';
import cn from 'classnames';
import { TextField } from 'seagull';
import { isValidHexColor } from "../../business-logic/colorsLogic";
import { ColorSelector } from "../ColorSelector/ColorSelector";
import styles from "./ColorPicker.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders a text input for HEX values with a preview on the right for the color,
 * which is also a native color picker when clicked.
 */
export function ColorPicker(props) {
  const {
    color,
    className,
    testId,
    selected,
    displayColor,
    onChange,
    onBlur,
    label,
    colorAsSuffix,
    inputWrapperClassName,
    noMinWidth
  } = props;
  const colorInputRef = useRef(null);
  const isValidColor = isValidHexColor(color);
  useEffect(() => {
    if (onBlur && colorInputRef.current) {
      const inputEl = colorInputRef.current;
      inputEl.addEventListener('change', onBlur);
      return () => {
        inputEl.removeEventListener('change', onBlur);
      };
    }
  }, [onBlur]);
  const colorSwatch = /*#__PURE__*/_jsx(ColorSelector, {
    withBorder: true,
    hasError: !isValidColor,
    selected: selected,
    color: displayColor || 'linear-gradient(180deg, #EB3563 0%, #6564F6 51.56%, #84F96B 100%)',
    onClick: () => {
      var _colorInputRef$curren;
      return (_colorInputRef$curren = colorInputRef.current) === null || _colorInputRef$curren === void 0 ? void 0 : _colorInputRef$curren.click();
    }
  });
  const suffix = colorAsSuffix ? /*#__PURE__*/_jsx("span", {
    className: styles.suffixTrigger,
    onClick: () => {
      var _colorInputRef$curren2;
      return (_colorInputRef$curren2 = colorInputRef.current) === null || _colorInputRef$curren2 === void 0 ? void 0 : _colorInputRef$curren2.click();
    },
    role: "button",
    tabIndex: 0,
    onKeyDown: e => {
      var _colorInputRef$curren3;
      return e.key === 'Enter' && ((_colorInputRef$curren3 = colorInputRef.current) === null || _colorInputRef$curren3 === void 0 ? void 0 : _colorInputRef$curren3.click());
    },
    children: colorSwatch
  }) : null;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, className, colorAsSuffix && styles.rootSuffix, noMinWidth && styles.noMinWidth),
    "data-testid": testId !== null && testId !== void 0 ? testId : undefined,
    children: [colorAsSuffix ? /*#__PURE__*/_jsx("span", {
      className: cn(styles.fullWidthInputWrapper, inputWrapperClassName),
      children: /*#__PURE__*/_jsx(TextField, {
        collapseHelperText: false,
        size: "small",
        prefix: "#",
        suffix: suffix,
        disableSuffixPadding: true,
        label: label || 'Customize color',
        testId: testId && "".concat(testId, "-text"),
        value: color.slice(1),
        error: !isValidColor,
        helperText: isValidColor ? '' : '3 or 6 valid digits please',
        onChange: function (_onChange) {
          function onChange(_x) {
            return _onChange.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange.toString();
          };
          return onChange;
        }(e => onChange("#".concat(e.target.value))),
        onBlur: onBlur
      })
    }) : /*#__PURE__*/_jsx(TextField, {
      collapseHelperText: false,
      size: "small",
      prefix: "#",
      label: label || 'Customize color',
      testId: testId && "".concat(testId, "-text"),
      value: color.slice(1),
      error: !isValidColor,
      helperText: isValidColor ? '' : '3 or 6 valid digits please',
      onChange: function (_onChange2) {
        function onChange(_x2) {
          return _onChange2.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange2.toString();
        };
        return onChange;
      }(e => onChange("#".concat(e.target.value))),
      onBlur: onBlur
    }), colorAsSuffix ? /*#__PURE__*/_jsx("input", {
      ref: colorInputRef,
      className: styles.input,
      type: "color",
      value: color,
      onChange: function (_onChange3) {
        function onChange(_x3) {
          return _onChange3.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange3.toString();
        };
        return onChange;
      }(e => onChange(e.target.value)),
      "aria-hidden": true,
      tabIndex: -1
    }) : /*#__PURE__*/_jsxs("div", {
      className: styles.previewWrapper,
      children: [colorSwatch, /*#__PURE__*/_jsx("input", {
        ref: colorInputRef,
        className: styles.input,
        type: "color",
        value: color,
        onChange: function (_onChange4) {
          function onChange(_x4) {
            return _onChange4.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange4.toString();
          };
          return onChange;
        }(e => onChange(e.target.value))
      })]
    })]
  });
}